const Namespace = {
  glossary: 'glossary',
  phrases: 'phrases',
  AppLibrary: 'AppLibrary',
  AppLibraryPersonal: 'AppLibraryPersonal',
  ContentWrapper: 'ContentWrapper',
  Linkchooser: 'Linkchooser',
  AttachedFiles: 'AttachedFiles',
  StatusBadge: 'StatusBadge',
  Breadcrumb: 'Breadcrumb',
  BlogPostSiblings: 'BlogPostSiblings',
  ChildPagesTree: 'ChildPagesTree',
  ConnectedLocations: 'ConnectedLocations',
  ConnectedOrgUnits: 'ConnectedOrgUnits',
  ConnectedProcesses: 'ConnectedProcesses',
  Collapsible: 'Collapsible',
  ConnectedPageContentListItem: 'ConnectedPageContentListItem',
  ConnectedPages: 'ConnectedPages',
  ConnectedPageListItem: 'ConnectedPageListItem',
  ContactPerson: 'ContactPerson',
  ContentAttachmentList: 'ContentAttachmentList',
  ContentMetainfo: 'ContentMetainfo',
  ConnectedPagesGraph: 'ConnectedPagesGraph',
  ContentSearchResults: 'ContentSearchResults',
  ContentImage: 'ContentImage',
  ColorSchemeSettings: 'ColorSchemeSettings',
  DateFormat: 'DateFormat',
  DateRanger: 'DateRanger',
  Download: 'Download',
  DefaultForMembersWithParentTask: 'DefaultForMembersWithParentTask',
  DefaultForMembersWithParentTeamroom: 'DefaultForMembersWithParentTeamroom',
  DefaultForMembersWithParentTopic: 'DefaultForMembersWithParentTopic',
  DefaultForMembersWithParentOrgunit: 'DefaultForMembersWithParentOrgunit',
  DefaultForMembersWithParentLocation: 'DefaultForMembersWithParentLocation',
  DefaultForMembersWithParentProcess: 'DefaultForMembersWithParentProcess',
  DefaultForNewsletterFrequency: 'DefaultForNewsletterFrequency',
  ErrorDisabledJavascript: 'ErrorDisabledJavascript',
  ExternalContent: 'ExternalContent',
  PdfFileDetails: 'PdfFileDetails',
  Form: 'Form',
  GenericSearchList: 'GenericSearchList',
  PersonCollectionBlock: 'PersonCollectionBlock',
  CellFactory: 'CellFactory',
  FileUpload: 'FileUpload',
  FormDateTime: 'FormDateTime',
  FormInput: 'FormInput',
  FormLabel: 'FormLabel',
  FormHelp: 'FormHelp',
  FormSubmitOrCancel: 'FormSubmitOrCancel',
  ImageCropper: 'ImageCropper',
  ImageUpload: 'ImageUpload',
  ImageGallery: 'ImageGallery',
  IFrame: 'IFrame',
  LatestAddition: 'LatestAddition',
  MemberRequestListItem: 'MemberRequestListItem',
  MemberRow: 'MemberRow',
  NewsletterSettingsForm: 'NewsletterSettingsForm',
  PageLead: 'PageLead',
  PageInteractionsRecommendations: 'PageInteractionsRecommendations',
  PageListDetails: 'PageListDetails',
  PersonInfoCard: 'PersonInfoCard',
  PersonInformation: 'PersonInformation',
  PersonProfileImageSmall: 'PersonProfileImageSmall',
  ResultListSettings: 'ResultListSettings',
  RolePrivilegeConfig: 'RolePrivilegeConfig',
  SearchBreadcrumb: 'SearchBreadcrumb',
  FormDateRange: 'FormDateRange',
  SearchFormResults: 'SearchFormResults',
  SearchResultTeaser: 'SearchResultTeaser',
  ContentSearchStatistics: 'ContentSearchStatistics',
  StructuralPageToPage: 'StructuralPageToPage',
  SkipLinks: 'SkipLinks',
  Widget: 'Widget',
  ConnectedTopics: 'ConnectedTopics',
  ContactPersons: 'ContactPersons',
  ContentSearch: 'ContentSearch',
  Error: 'Error',
  EventIcalDownload: 'EventIcalDownload',
  EventDetails: 'EventDetails',
  EventList: 'EventList',
  EventManagement: 'EventManagement',
  EventCreateOrUpdate: 'EventCreateOrUpdate',
  ExternalLinks: 'ExternalLinks',
  LatestForumPosts: 'LatestForumPosts',
  Calendar: 'Calendar',
  ExternalLinkDetails: 'ExternalLinkDetails',
  PageLayout: 'PageLayout',
  PortalAvatar: 'PortalAvatar',
  PortalLogo: 'PortalLogo',
  PortalTitle: 'PortalTitle',
  Newsletterfooter: 'Newsletterfooter',
  PersonalDataProcessingText: 'PersonalDataProcessingText',
  PersonProfileEditHintConfig: 'PersonProfileEditHintConfig',
  RegistrationEmail: 'RegistrationEmail',
  PageSettings: 'PageSettings',
  LatestAdditions: 'LatestAdditions',
  MainNavigation: 'MainNavigation',
  MemberRequestList: 'MemberRequestList',
  DownloadByteUnit: 'DownloadByteUnit',
  Editor: 'Editor',
  ErrorInfo: 'ErrorInfo',
  FilterEventType: 'FilterEventType',
  FooterSection: 'FooterSection',
  FormMultiselectPanel: 'FormMultiselectPanel',
  FormRequiredSymbol: 'FormRequiredSymbol',
  FormsComboBox: 'FormsComboBox',
  FormsComboBoxMultiSelect: 'FormsComboBoxMultiSelect',
  HeaderSection: 'HeaderSection',
  Image: 'Image',
  InstantSearch: 'InstantSearch',
  LoadingFeedback: 'LoadingFeedback',
  LoadingSpinner: 'LoadingSpinner',
  LoadMore: 'LoadMore',
  Pagination: 'Pagination',
  PersonalAccessLibrary: 'PersonalAccessLibrary',
  PersonalMessage: 'PersonalMessage',
  PersonalSection: 'PersonalSection',
  SearchResults: 'SearchResults',
  SearchForm: 'SearchForm',
  TextMarker: 'TextMarker',
  UserSearchResults: 'UserSearchResults',
  Members: 'Members',
  RichText: 'RichText',
  LoginDescription: 'LoginDescription',
  AToZContainer: 'AToZContainer',
  PageListTable: 'PageListTable',
  PageListTeaser: 'PageListTeaser',
  PageManagement: 'PageManagement',
  PageMetaInfo: 'PageMetaInfo',
  PageType: 'PageType',
  PageTypeCategories: 'PageTypeCategories',
  PagePropertySettingsForm: 'PagePropertySettingsForm',
  TransformPageType: 'TransformPageType',
  TeaserInformation: 'TeaserInformation',
  NavigationPropertiesForm: 'NavigationPropertiesForm',
  AccessKeysSettingsForm: 'AccessKeysSettingsForm',
  PersonContactData: 'PersonContactData',
  PersonAdditionalInformation: 'PersonAdditionalInformation',
  PersonAffiliation: 'PersonAffiliation',
  PersonExtendedData: 'PersonExtendedData',
  PageInteractions: 'PageInteractions',
  PageInteractionsWatchButton: 'PageInteractionsWatchButton',
  PersonInteraction: 'PersonInteraction',
  ProfileImage: 'ProfileImage',
  TeamroomManagement: 'TeamroomManagement',
  TeamroomCreateOrUpdate: 'TeamroomCreateOrUpdate',
  TitleImage: 'TitleImage',
  UpcomingEvents: 'UpcomingEvents',
  UserAccount: 'UserAccount',
  UserAnonymous: 'UserAnonymous',
  UserMemberships: 'UserMemberships',
  WatchedPageMessagesPanel: 'WatchedPageMessagesPanel',
  WithFooterLink: 'WithFooterLink',
  ChangePasswordUrl: 'ChangePasswordUrl',
  BlogAuthors: 'BlogAuthors',
  PageTypesList: 'PageTypesList',
  PageTypePageLead: 'PageTypePageLead',
  RolesList: 'RolesList',
  RolePageLead: 'RolePageLead',
  UserRegistration: 'UserRegistration',
  UserRegistrationForm: 'UserRegistrationForm',
  UserRegistrationPresets: 'UserRegistrationPresets',
  PasswordReset: 'PasswordReset',
  Announcement: 'Announcement',
  ConfigurationAggregate: 'ConfigurationAggregate',
  CompositionConfiguration: 'CompositionConfiguration',
  PluginConfiguration: 'PluginConfiguration',
  ThemeColorForm: 'ThemeColorForm',
  InputCounter: 'InputCounter',
  AddContentBlockForm: 'AddContentBlockForm',
  PageState: 'PageState',
  FaqList: 'FaqList',
  HintBlock: 'HintBlock',
  VideoBlock: 'VideoBlock',
  Video: 'Video',
  VideoUpload: 'VideoUpload',
  TopHeadlinesForm: 'TopHeadlinesForm',
  MultiStepForm: 'MultiStepForm',
  LayoutGroup: 'LayoutGroup',
  TableOfContents: 'TableOfContents',
  ChildPagesBlock: 'ChildPagesBlock',
  DeviatingValidityPeriods: 'DeviatingValidityPeriods',
  RoleSettings: 'RoleSettings',
  RoleSettingsForm: 'RoleSettingsForm',
  PageMembershipMatchingRuleSettings: 'PageMembershipMatchingRuleSettings',
  PageMembershipMatchingRuleSettingsForm: 'PageMembershipMatchingRuleSettingsForm',
  PageMembershipMatchingRulePageLead: 'PageMembershipMatchingRulePageLead',
  TicketBooking: 'TicketBooking',
  ChangeEmailAddress: 'ChangeEmailAddress',

  // Settings
  SupportEmail: 'SupportEmail',
  PortalInformationLink: 'PortalInformationLink',
  GoliveModeEnabled: 'GoliveModeEnabled',
  AnonymousAccessEnabled: 'AnonymousAccessEnabled',
  UserRegistrationEnabled: 'UserRegistrationEnabled',
  InviteUnregisteredEnabled: 'InviteUnregisteredEnabled',
  SessionRestrictorEnabled: 'SessionRestrictorEnabled',
  PortalUserRegistrationEnabled: 'PortalUserRegistrationEnabled',
  HighestConfidentialLevel: 'HighestConfidentialLevel',
  DefaultConfidentialLevel: 'DefaultConfidentialLevel',
  PrintingDependsOnConfidentialLevels: 'PrintingDependsOnConfidentialLevels',
  ExtendedProtocolReadAccessEnabled: 'ExtendedProtocolReadAccessEnabled',
  ExtendedProtocolWriteAccessAdminContentEnabled: 'ExtendedProtocolWriteAccessAdminContentEnabled',
  ExtendedProtocolWriteAccessUserContentEnabled: 'ExtendedProtocolWriteAccessUserContentEnabled',
  AllowedMimeTypes: 'AllowedMimeTypes',
  CspFrameSourceConfig: 'CspFrameSourceConfig',
  Keywords: 'Keywords',
  DepublishPagesWithExceededValidityPeriodEnabled: 'DepublishPagesWithExceededValidityPeriodEnabled',
  FormColorChooser: 'FormColorChooser',
  PageTypeValidityPeriod: 'PageTypeValidityPeriod',
  PageLockValidityPeriod: 'PageLockValidityPeriod',
  AreaGroups: 'AreaGroups',
  ReadAllAccessBanner: 'ReadAllAccessBanner',
  UserImportSystemServiceEnabled: 'UserImportSystemServiceEnabled',
  PageMembershipMatcherSystemServiceEnabled: 'PageMembershipMatcherSystemServiceEnabled',

  // Email
  Email: 'Email',
  PasswordResetEmail: 'PasswordResetEmail',
  PasswordSetEmail: 'PasswordSetEmail',
  AlreadyRegistered: 'alreadyRegistered',
  Registration: 'registration',
  Newsletter: 'newsletter',
  ChangeEmailConfirmation: 'ChangeEmailConfirmation',
  EmailChangeRequestWasMade: 'EmailChangeRequestWasMade',
  TicketBookingEmail: 'TicketBookingEmail',
  FormApplicationResultUpdatedMail: 'FormApplicationResultUpdatedMail',

  Wysiwyg: 'Wysiwyg',
  AccessKeys: 'AccessKeys',
  ModalDialog: 'ModalDialog',
  TopHeadlines: 'TopHeadlines',
  SortableList: 'SortableList',
  CreatePage: 'CreatePage',
  SortChildPagesForm: 'SortChildPagesForm',
  PageArticles: 'PageArticles',
  On2Content: 'On2Content',
  FavoritedPages: 'FavoritedPages',
  FavoritedUsers: 'FavoritedUsers',
  ThreadlistBlock: 'ThreadlistBlock',
  AcceptDeclineForm: 'AcceptDeclineForm',
  EditorFeedback: 'EditorFeedback',
  CollapsibleContainerBlock: 'CollapsibleContainerBlock',
  ExecutiveOrganisationChartPrint: 'ExecutiveOrganisationChartPrint',
} as const;

export { Namespace };
